import type { ComponentData } from '@puckeditor/core'

/** CSS display value that means "hide" — pruned from the resolved tree. */
export const DISPLAY_NONE = 'none'

/**
 * True when a value is a slot/zone (array of Puck ComponentData). Used to walk
 * nested components and to skip structural props when diffing.
 */
export function isComponentArray(value: unknown): value is ComponentData[] {
  return (
    Array.isArray(value) &&
    value.every(
      item =>
        !!item &&
        typeof item === 'object' &&
        'type' in (item as Record<string, unknown>) &&
        'props' in (item as Record<string, unknown>),
    )
  )
}

/** Component id as stored by Puck (`props.id`). */
export const getId = (node: ComponentData): string | undefined =>
  (node.props as { id?: string } | undefined)?.id
